import { render } from "./ScaleKubernetesCluster.vue?vue&type=template&id=6ba42fab&scoped=true"
import script from "./ScaleKubernetesCluster.vue?vue&type=script&lang=js"
export * from "./ScaleKubernetesCluster.vue?vue&type=script&lang=js"

import "./ScaleKubernetesCluster.vue?vue&type=style&index=0&id=6ba42fab&scoped=true&lang=less"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba42fab"]])

export default __exports__